export default __webpack_public_path__ + "static/media/lato-regular.0139b8ff.woff";